import React from 'react';
import { ActionButton, ActionButtonModel } from '@/store/videoFeatures';
import { ButtonContentCard } from '../shared/ButtonContentCard';
import { ButtonTimingCard } from '../shared/ButtonTimingCard';
import { ButtonStyleCard } from '../shared/ButtonStyleCard';
import { ButtonPreviewCard } from '../shared/ButtonPreviewCard';

interface BelowVideoTabProps {
  actionButton: Partial<ActionButton>;
  updateActionButton: (key: string, value: any) => void;
  updateTemplate: (key: string, value: any) => void;
  onSelectModel: (model: ActionButtonModel) => void;
}

export const BelowVideoTab: React.FC<BelowVideoTabProps> = ({
  actionButton,
  updateActionButton,
  updateTemplate,
  onSelectModel,
}) => {
  const updateStyleProperty = (property: string, value: any) => {
    const currentStyle = actionButton.style || {};
    updateActionButton('style', {
      ...currentStyle,
      [property]: value,
    });
  };

  const updateTimingProperty = (property: string | Record<string, any>, value?: any) => {
    const currentTiming = actionButton.timing || {};
    const updates = typeof property === 'object' ? property : { [property]: value };
    updateActionButton('timing', { ...currentTiming, ...updates });
  };

  return (
    <div className="space-y-5">
      <ButtonContentCard
        actionButton={actionButton}
        updateActionButton={updateActionButton}
        updateTemplate={updateTemplate}
        onSelectModel={onSelectModel}
      />

      <ButtonTimingCard
        actionButton={actionButton}
        updateTimingProperty={updateTimingProperty}
      />

      <ButtonStyleCard
        actionButton={actionButton}
        updateStyleProperty={updateStyleProperty}
        updateTemplate={updateTemplate}
      />

      <ButtonPreviewCard actionButton={actionButton} />
    </div>
  );
};
